// 权限指令 - 用于按钮级显隐控制
// 使用: v-perm="'order:list'" 或 v-perm="['order:list', 'order:update']"
import store from '@/store'

const hasPermission = (value) => {
  if (!value) return true
  const codes = Array.isArray(value) ? value : [value]
  return codes.some(code => store.getters.hasPerm(code))
}

export default {
  install(app) {
    // 注册全局方法
    app.config.globalProperties.$hasPerm = hasPermission

    // 注册自定义指令
    app.directive('perm', {
      mounted(el, binding) {
        if (!hasPermission(binding.value)) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      }
    })
  }
}